import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '~/hooks/useHttpClient';
import { determineRetryAndMaybeLog } from '~/utils/errors';
import { createLogger } from '~/utils/logging';

import { type SchoolStudent } from './useSchoolStudentsQuery';

const log = createLogger('useSchoolStudentQuery');

export const SCHOOL_STUDENT_QUERY_KEY = 'schoolStudent';

export function useSchoolStudentQuery({ slug }: { slug: string | undefined }) {
  const httpClient = useHttpClient();

  const { data, error, status } = useQuery<SchoolStudent>({
    queryKey: [SCHOOL_STUDENT_QUERY_KEY, slug],
    queryFn: async () => {
      log.debug('Fetching school student', { slug });
      const response = await httpClient.get<SchoolStudent>(
        `/student/getSchoolStudent?${new URLSearchParams({ slug: slug! })}`,
      );
      log.info('Fetched school student', { studentId: response.studentId });
      return response;
    },
    retry: (failureCount, error) =>
      determineRetryAndMaybeLog({ operation: 'fetch school student', failureCount, error, log }),
    enabled: slug != null && httpClient.isAuthenticated,
  });

  return { data, error, status };
}
